
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  skipLLM: true,
  maxTocLevel: 4,
  description: 'Turn your customers\' everyday purchases into personalized cashback rewards with the Cardlytics Rewards Platform.'
};
export const partnerProps = {
  partner: 'Cardlytics',
  clientLibrary: 'cardlytics',
  subtitle: metadata.description,
  registrationUrl: 'https://go.cardlytics.com/CardlyticsRewardsPlatform',
  apiUrl: 'https://platform.cardlytics.com/publisher-integrations/docs/welcome',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Cardlytics have partnered to help publishers and retailers deliver personalized cashback rewards to their customers with ease. Cardlytics leverages purchase history to match customers with tailored cashback offers from top brands and retailers, driving loyalty, engagement, and incremental spend. With the Plaid + Cardlytics integration, partners can provide a seamless, secure rewards experience that keeps customers coming back.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
